import React from "react";
import { Satellite, Radar, Activity, PlugZap } from "lucide-react";
import { fmtDateTime } from "../lib/utils";
import { PageHeader } from "../components/core/Layout";
import { GeotabConnectionCard, useTelematicsStatus } from "../components/telematics/GeotabConnectionCard";

export default function TelematicsSettingsPage() {
  const { data: status } = useTelematicsStatus();
  return (
    <div data-testid="telematics-settings-page">
      <PageHeader eyebrow="Settings" title="Telematics connection" subtitle="Connect your MyGeotab account so the Live Map, trips and device linking use real vehicle data." />
      <div className="grid gap-5 lg:grid-cols-12">
        <div className="lg:col-span-7"><GeotabConnectionCard /></div>
        <div className="space-y-3 lg:col-span-5">
          {[
            { icon: Satellite, label: "Provider", value: "Geotab" },
            { icon: PlugZap, label: "Connection", value: status?.connected ? `Connected${status.config?.is_mock ? " · mock sandbox" : ""}` : "Not connected", tone: status?.connected ? "text-emerald-700" : "text-amber-700" },
            { icon: Radar, label: "Linked devices", value: String(status?.linked_devices ?? 0) },
            { icon: Activity, label: "Last sync", value: status?.last_sync_at ? fmtDateTime(status.last_sync_at) : "Never" },
          ].map((s) => <div key={s.label} className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2" data-testid={`telematics-settings-${s.label.toLowerCase().replace(" ", "-")}`}><s.icon className="h-4 w-4 text-slate-400" /><span className="text-xs text-slate-500">{s.label}</span><span className={`ml-auto text-sm font-semibold ${s.tone || "text-slate-900"}`}>{s.value}</span></div>)}
          {status?.config?.last_error && <p className="rounded-lg border border-rose-200 bg-rose-50 p-2 text-xs text-rose-800" data-testid="telematics-settings-error">{status.config.last_error}</p>}
        </div>
      </div>
    </div>
  );
}
